import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

const Bookmarks = () => {
    const nav = useNavigate('');
    const [datak, setdata] = useState([]);
    const [end, setend] = useState(6)


    const { idk } = useSelector((state) => state)

    const fetchData = async () => {
        let resp = await fetch(`http://localhost:9000/api/getbookmarks/${idk}`);
        if (resp.ok) {
            let res = await resp.json();
            if (res.statuscode === 1) {
                setdata(res.bookmarks);
            }
        }
    }

    useEffect(()=>{
        fetchData();
    }, [idk])
    return (
        <>

            <div className="container">
                <div className="row">
                    {
                        datak.map((data, ind) => (
                            <>
                                <div key={ind} id="cardt" className="col-lg-4">
                                    <div> <img onClick={() => nav(`/view?idtb=${data.urlidk}`)} src={data.url} className="img-fluid" /> </div>
                                </div>

                            </>
                        ))}
                </div>
            </div>

        </>

    );
}

export default Bookmarks;